// markerIcons.js
import L from "leaflet";

export const createPinIcon = (color, isHighlighted = false) => {
  return L.divIcon({
    className: "custom-pin-marker",
    html: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="16" height="24">
        <path 
          d="M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480l0-162.9c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9L192 480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
          fill="${color}"
          stroke="#fff"
          stroke-width="${isHighlighted ? "1" : "0.5"}"
        />
      </svg>
    `,
    iconSize: [16, 24],
    iconAnchor: [8, 24],
    popupAnchor: [0, -24],
  });
};

export const createCustomIcon = (
  color,
  isHighlighted = false,
  isCurrentDeal = false,
  isGroupFacility = false
) => {
  // Size based on whether it's current deal
  const size = isCurrentDeal ? 32 : 24;
  const height = size * 1.5;

  return L.divIcon({
    className: "custom-marker",
    html: `
        <svg width="${size}" height="${height}" viewBox="-2 -2 28 40">
          <path d="M12 0C5.383 0 0 5.383 0 12c0 9.941 12 24 12 24s12-14.059 12-24C24 5.383 18.617 0 12 0z" 
                fill="${color}"
                stroke="${isCurrentDeal ? "#000" : "#fff"}"
                stroke-width="${
                  isCurrentDeal ? "2.5" : isHighlighted ? "2" : "1.5"
                }"
          />
          <circle cx="12" cy="12" r="6" fill="#fff"/>
        </svg>
      `,
    iconSize: [size, height],
    iconAnchor: [size / 2, height],
    popupAnchor: [0, -height],
  });
};
